export const MESH_SAMPLE_NAME = "forgelinc-wedge.stl";
export const READY_TO_SEND = "ready_to_send";

export const HIGHLIGHT_COLORS = [
  { id: "mark", label: "Mark", value: "#ff3b6b" },
  { id: "amber", label: "Amber", value: "#ffb020" },
  { id: "cyan", label: "Cyan", value: "#3ee0ff" },
  { id: "lime", label: "Lime", value: "#b6ff4a" },
];

export function classifyMeshName(filename) {
  const name = String(filename || "").trim();
  if (/\.gcode\.3mf$/i.test(name)) return { format: null, reason: "sliced" };
  const match = name.toLowerCase().match(/\.(stl|glb|gltf|3mf)$/);
  if (!match) return { format: null, reason: "unsupported" };
  return { format: match[1], reason: null };
}

export const MESH_UPLOAD_LIMIT = 32 * 1024 * 1024;

export function listMeshesFromRecord(record) {
  const meta = record?.metadata || {};
  const sourceId = meta.session_source?.kind === "mesh" ? meta.session_source.artifact_id : null;
  const rows = [];
  const seen = new Set();
  const push = (artifact, origin) => {
    if (!artifact || typeof artifact !== "object") return;
    const info = classifyMeshName(artifact.filename);
    if (!info.format || !artifact.id || !artifact.storage_key) return;
    if (seen.has(artifact.id)) return;
    seen.add(artifact.id);
    const downloadPath = `/businesses/linkforge/records/${record.id}/meshes/${artifact.id}${info.format === "3mf" ? "?as=stl" : ""}`;
    rows.push({
      id: artifact.id,
      filename: artifact.filename,
      format: info.format,
      origin: artifact.id === sourceId ? "source" : origin,
      downloadPath,
    });
  };
  push(meta.design_artifact, "design");
  for (const row of meta.mesh_assets || []) push(row, "mesh");
  const loop = meta.print_loop || {};
  for (const row of loop.orca?.files || []) push(row, "orca");
  for (const entry of loop.studio_returns || []) {
    for (const row of entry?.files || []) push(row, "studio");
  }
  rows.sort((a, b) => Number(b.origin === "source") - Number(a.origin === "source"));
  return rows;
}

export function undoLastStroke(strokes) {
  return Array.isArray(strokes) ? strokes.slice(0, -1) : [];
}

export function validateReprocessNote(note) {
  const text = String(note || "").trim();
  if (!text) return "Add a short change note before sending.";
  if (text.length > 500) return "Change note must be 500 characters or fewer.";
  return "";
}

export function reprocessStatusLabel(pkg) {
  if (!pkg) return "";
  if (pkg.status === READY_TO_SEND && pkg.live_call === false) return "Ready to send";
  return pkg.status || "";
}

export function formatMillimetres(size) {
  if (!size) return "";
  const part = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return "—";
    const abs = Math.abs(num);
    if (abs >= 100) return num.toFixed(0);
    if (abs >= 10) return num.toFixed(1);
    return num.toFixed(2);
  };
  return `${part(size.x)} × ${part(size.y)} × ${part(size.z)} mm`;
}

export function clampBrushScale(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 1;
  return Math.min(8, Math.max(0.25, num));
}

export function dataUrlToBlob(dataUrl) {
  const value = String(dataUrl || "");
  const splitAt = value.indexOf(",");
  if (splitAt < 0) throw new Error("Screenshot was empty.");
  const head = value.slice(0, splitAt);
  const body = value.slice(splitAt + 1);
  const mime = /data:(.*?);/.exec(head)?.[1] || "image/png";
  const binary = atob(body);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return new Blob([bytes], { type: mime });
}
